import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import TaskForm from '../components/TaskForm';

const AddTaskPage = () => {
  const { taskId } = useParams();
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    if (taskId) {
      setEditMode(true);
    }
  }, [taskId]);

  return (
    <>
      <Navbar />
      <div className="container relative">
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
            {editMode ? 'Edit' : 'Create'} Task for Your Team
          </h1>

          <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
            <TaskForm editMode={editMode} id={taskId} />
          </div>
        </main>
      </div>
    </>
  );
};

export default AddTaskPage;
